import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  DownloadMsg,
  NotificationCategoryEnum,
  NotificationMsg,
  PagedData
} from '../models/general.models';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private baseUrl: string = environment.baseUrl;
  private _NotificationsArray: Array<NotificationMsg> = [];
  private _DownloadsArray: Array<DownloadMsg> = [];

  constructor(private http: HttpClient) {}

  public get DownloadsArray(): Array<DownloadMsg> {
    return this._DownloadsArray;
  }

  public updateDownload(updatedBody: DownloadMsg) {
    const indexToUpdate = this._DownloadsArray.findIndex(
      (el) => el.fileName === updatedBody.fileName
    );
    if (indexToUpdate == -1) {
      updatedBody.percentage !== 100 && this._DownloadsArray.push(updatedBody);
    } else {
      if (updatedBody.percentage >= 100) {
        this._DownloadsArray.splice(indexToUpdate, 1);
      } else this._DownloadsArray[indexToUpdate] = updatedBody;
    }
  }

  public getNotifications(): Observable<PagedData<NotificationMsg>> {
    const endpoint = `${this.baseUrl}/notifications?skip=0&limit=50&unread_only=false`;
    return this.http.get<PagedData<NotificationMsg>>(endpoint);
  }

  public readNotification(
    notification: NotificationMsg
  ): Observable<NotificationMsg> {
    const endpoint = `${this.baseUrl}/notifications/${notification.id}/read`;
    notification.read = true;
    return this.http.put<NotificationMsg>(endpoint, {});
  }

  public get NotificationsArray(): Array<NotificationMsg> {
    return this._NotificationsArray;
  }

  public set NotificationsArray(value: Array<NotificationMsg>) {
    this._NotificationsArray = value;
  }

  public updateNotificationById(updatedBody: NotificationMsg) {
    const indexToUpdate = this._NotificationsArray.findIndex(
      (el) => el.id === updatedBody.id
    );
    this._NotificationsArray[indexToUpdate] = updatedBody;
  }

  public getSubCategoryType(notification: NotificationMsg) {
    switch (notification.category) {
      case NotificationCategoryEnum.PROJECT_ARCHIVED:
        return 'archived';
      case NotificationCategoryEnum.USER_ADDED_TO_TEAM:
      case NotificationCategoryEnum.USER_ROLE_UPDATED:
      case NotificationCategoryEnum.USER_REMOVED_FROM_TEAM:
        return 'Settings';
      case NotificationCategoryEnum.USER_REMOVED_FROM_PROJECT:
        return 'unshare';
      case NotificationCategoryEnum.PROJECT_DELETED:
        return 'remove';
      case NotificationCategoryEnum.USER_ADDED_TO_PROJECT:
        return 'Shared';
      // New categories for WebSocket notifications
      case 'GLOBAL':
        return 'global';
      case 'SHARE':
        return 'share';
      case 'AREA':
        return 'area';
      case 'PROJECT':
        return 'project';
      case 'DOWNLOAD':
        return 'download';
      case 'REPORT':
        return 'report';
      default:
        return 'Shared';
    }
  }
  public getCategoryType(notification: NotificationMsg) {
    switch (notification.category) {
      case NotificationCategoryEnum.USER_ADDED_TO_TEAM:
      case NotificationCategoryEnum.USER_ROLE_UPDATED:
      case NotificationCategoryEnum.USER_REMOVED_FROM_TEAM:
        return "<span class='icon-warning'></span>";
      case NotificationCategoryEnum.PROJECT_ARCHIVED:
      case NotificationCategoryEnum.PROJECT_DELETED:
      case NotificationCategoryEnum.USER_ADDED_TO_PROJECT:
      case NotificationCategoryEnum.USER_REMOVED_FROM_PROJECT:
        return "<span class='icon-chat'></span>";
      // New categories for WebSocket notifications
      case 'GLOBAL':
        return "<span class='icon-globe'></span>";
      case 'SHARE':
        return "<span class='icon-share'></span>";
      case 'AREA':
        return "<span class='icon-area'></span>";
      case 'PROJECT':
        return "<span class='icon-project'></span>";
      case 'DOWNLOAD':
        return "<span class='icon-download'></span>";
      case 'REPORT':
        return "<span class='icon-report'></span>";
      default:
        return "<span class='icon-chat'></span>";
    }
  }

  // New methods for the updated API

  public markAllAsRead(): Observable<any> {
    const endpoint = `${this.baseUrl}/notifications/read-all`;
    return this.http.put<any>(endpoint, {});
  }

  public getUnreadCount(): Observable<{ count: number }> {
    const endpoint = `${this.baseUrl}/notifications/unread-count`;
    return this.http.get<{ count: number }>(endpoint);
  }
}
